/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Con2Inputs */

const en_fc_home_review_con2 = /** @type {(inputs: Fc_Home_Review_Con2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No .prproj import yet. Move projects over with XML, AAF or EDL.`)
};

/**
* | output |
* | --- |
* | "No .prproj import yet. Move projects over with XML, AAF or EDL." |
*
* @param {Fc_Home_Review_Con2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_con2 = /** @type {((inputs?: Fc_Home_Review_Con2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Con2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_con2(inputs)
});
export { fc_home_review_con2 as "fc.home.review.con2" }